<div class="announcement-dialog">
  <div
    [innerHTML]="header() | textResource | async | safeHtml"
    class="header"
  ></div>

  @if (content()) {
    <div
      class="description announcement-dialog-content ql-editor"
      tabindex="0"
      [innerHTML]="content() | textResource | async | safeHtml"
    ></div>
  } @else {
    <div class="description announcement-dialog-content">
      <ng-container *ngComponentOutlet="component()"></ng-container>
    </div>
  }

  <div class="buttons">
    @if (requiresConfirmation()) {
      <p-button
        [label]="'Potwierdzam otrzymanie'"
        (click)="confirmAnnouncement()"
        styleClass="customInfoButton"
        size="small"
      ></p-button>
    } @else {
      <p-button
        [label]="'Zamknij'"
        (click)="dynamicDialogRef.close()"
        styleClass="customInfoButton"
        size="small"
      ></p-button>
    }
  </div>
</div>
